import { UserRegistrationPeriod } from '../../api/generated/data-contracts';
import { MathToFixed } from '../Utils';

/**
 * Calculates the remaining work to display for a time entry.
 * Priority:
 * 1) Use remainingWork if > 0
 * 2) Calculate from planned - actual if planned > 0
 * 3) Return null
 * @param time - The user registration period containing work values
 * @returns Formatted remaining work value or null
 */
export function calculateDisplayedRemainingWork(time: UserRegistrationPeriod): number | null {
    const remainingWork = time.remainingWork ?? 0;
    const plannedWork = time.plannedWork ?? 0;
    const actualWork = time.actualWork ?? 0;

    // If explicit remaining work exists and is positive, use it
    if (remainingWork > 0) {
        return MathToFixed(remainingWork, 2);
    }

    // If planned work exists, calculate remaining as planned - actual (minimum 0)
    if (plannedWork > 0) {
        const calculatedRemaining = Math.max(plannedWork - actualWork, 0);
        return MathToFixed(calculatedRemaining, 2);
    }

    // No remaining work to display
    return null;
}
